import Vue from 'vue'
import Router from 'vue-router'

import store from '@/stores/index'
import toastr from '@/toastr'

import Home from '@/components/Home'
import HomeMobile from '@/components/HomeMobile'
import ErrorNotFound from '@/components/Global/ErrorNotFound'
import Exports from '@/components/Exports'

import SecurityRouter from '@/components/Security/router'
import UserRouter from '@/components/User/router'
import RoleRouter from '@/components/Role/router'
import WarehouseRouter from '@/components/Warehouse/router'
import StorageZoneRouter from '@/components/StorageZone/router'
import StorageEnvironmentRouter from '@/components/StorageEnvironment/router'
import CategoryWarehouseRouter from '@/components/CategoryWarehouse/router'
import DepartmentWarehouseRouter from '@/components/DepartmentWarehouse/router'
import WarehouseTransferRouter from '@/components/WarehouseTransfer/router'
import ExchangeRouter from '@/components/Exchange/router'
import CompanyRouter from '@/components/Company/router'
import CompanyContactRouter from '@/components/CompanyContact/router'
import CompanyGroupRouter from '@/components/CompanyGroup/router'
import ReferenceRouter from '@/components/Reference/router'
import ReferenceMobileRouter from '@/components/ReferenceMobile/router'
import SparePartRouter from '@/components/SparePart/router'
import RentingRouter from '@/components/Renting/router'
import RentingPreparationRouter from '@/components/RentingPreparation/router'
import RentingPreparationMobileRouter from '@/components/RentingPreparationMobile/router'
import BusinessReturnRouter from '@/components/BusinessReturn/router'
import BusinessReturnMobileRouter from '@/components/BusinessReturnMobile/router'
import ReceptionMobileRouter from '@/components/ReceptionMobile/router'
import TransferRouter from '@/components/Transfer/router'
import ShippingRouter from '@/components/Shipping/router'
import ShippingMobileRouter from '@/components/ShippingMobile/router'
import ComplaintRouter from '@/components/Complaint/router'
import AxilocSettingRouter from '@/components/AxilocSetting/router'
import FeaturedProductRouter from '@/components/FeaturedProduct/router'
import TransportRateRouter from '@/components/TransportRate/router'
import RequestAttributeRouter from '@/components/RequestAttribute/router'
import FeeLabelRouter from '@/components/FeeLabel/router'
import LocationForAccountRouter from '@/components/LocationForAccount/router'
import PendingFeeRouter from '@/components/PendingFee/router'
import FaqRouter from '@/components/Faq/router'
import MyaxilocSettingRouter from '@/components/MyaxilocSetting/router'
import ExternalMaintenanceRouter from '@/components/ExternalMaintenance/router'
import ManualBillingRouter from '@/components/ManualBilling/router'
import AutomaticBillingRouter from '@/components/AutomaticBilling/router'
import OverdueMaintenanceReferenceRouter from '@/components/OverdueMaintenanceReference/router'
import AgencyRentingsRouter from '@/components/AgencyRentings/router'
import ProductRouter from '@/components/Product/router'
import ProductMobileRouter from '@/components/ProductMobile/router'
import AgencyRouter from '@/components/Agency/router'
import AgencyGroupRouter from '@/components/AgencyGroup/router'
import BusinessRouter from '@/components/Business/router'
import EmployeeRouter from '@/components/Employee/router'
import NotBillableBusinessRouter from '@/components/NotBillableBusiness/router'
import PopupRouter from '@/components/Popup/router'
import TheTeamRouter from '@/components/TheTeam/router'
import axios from '@/axiosConnection'

Vue.use(Router)

const APP_TITLE = 'MY E-MATERIEL'

let router = new Router({
  mode: 'history',
  /**
   * Vue Router laisse par défaut la page où elle était : en cliquant une ligne en bas
   * d'une liste, la fiche s'ouvrait à mi-hauteur, en-tête et onglets hors écran.
   *
   * - retour arrière : on rend la position quittée, pour retrouver sa ligne dans la liste ;
   * - même chemin : on ne touche à rien. Les listes réécrivent la query à chaque frappe
   *   dans la recherche (`AdminTableSync.syncFiltersToUrl` -> `$router.replace`), remonter
   *   à chaque caractère saisi rendrait le filtrage inutilisable. La pagination, elle,
   *   remonte via son propre watcher `currentPage` ;
   * - sinon : haut de page.
   */
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.path === from.path) return;

    return { x: 0, y: 0 };
  },
  routes: [{
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: "Vue d'ensemble",
        requiresAuth: true,
        authorizations: ['desktop_access']
      }
    },
    {
      path: '/mobile',
      name: 'HomeMobile',
      component: HomeMobile,
      meta: {
        title: "Vue d'ensemble",
        requiresAuth: true,
        authorizations: ['mobile_access']
      }
    },{
      path: '/exports',
      name: 'Exports',
      component: Exports,
      meta: {
        title: 'Extraction',
        requiresAuth: true,
        authorizations: ['exports', 'desktop_access']
      }
    }
  ].concat(
    SecurityRouter,
    UserRouter,
    RoleRouter,
    WarehouseRouter,
    StorageZoneRouter,
    StorageEnvironmentRouter,
    CategoryWarehouseRouter,
    DepartmentWarehouseRouter,
    WarehouseTransferRouter,
    ExchangeRouter,
    CompanyRouter,
    CompanyContactRouter,
    CompanyGroupRouter,
    ReferenceRouter,
    ReferenceMobileRouter,
    SparePartRouter,
    RentingRouter,
    RentingPreparationRouter,
    RentingPreparationMobileRouter,
    BusinessReturnRouter,
    BusinessReturnMobileRouter,
    ReceptionMobileRouter,
    TransferRouter,
    ShippingRouter,
    ShippingMobileRouter,
    ComplaintRouter,
    MyaxilocSettingRouter,
    AxilocSettingRouter,
    FeaturedProductRouter,
    TransportRateRouter,
    RequestAttributeRouter,
    FeeLabelRouter,
    LocationForAccountRouter,
    PendingFeeRouter,
    ExternalMaintenanceRouter,
    ManualBillingRouter,
    AutomaticBillingRouter,
    OverdueMaintenanceReferenceRouter,
    AgencyRentingsRouter,
    ProductRouter,
    ProductMobileRouter,
    AgencyRouter,
    AgencyGroupRouter,
    BusinessRouter,
    EmployeeRouter,
    NotBillableBusinessRouter,
    FaqRouter,
    PopupRouter,
    TheTeamRouter
  ).concat([{
    path: '*',
    name: 'ErrorNotFound',
    component: ErrorNotFound,
    meta: {
      title: 'Page introuvable'
    }
  }])
})

router.beforeEach((to, from, next) => {

  // Vérifie sur la page en cours nécessite une authentification
  // Si oui, on vérifie que l'utilisateur est bien loggé, sinon on l'envoie sur la page login
  if (to.matched.some(record => record.meta.requiresAuth)) {

    // La déconnexion passe sans contrôle Azure
    if (to.name == "Logout") {
      next()
    } else if (to.name == "Azure") {
        this.a.app.$store.dispatch("auth/login", {
          code: to.query.code
        }).then(() => {
          router.push({ name: "Home" });
        })
    } else {
      // Si l'utilisateur a déjà une session ouverte sur l'app, on le laisse passer
      if (this.a.app.$store.getters['auth/isAuthenticated'] === true) {

        // Vérification que les données de base sont bien chargées, sinon on les charge avant tout
        if (this.a.app.$store.getters['app/isLoaded'] === true) {
          // Si il accède à la home, qu'il a l'accès mobile et qu'il est sur un appareil mobile, on le redirige sur la home mobile
          if (to.name == 'Home' && this.a.app.$store.getters["auth/isAuthorized"]('mobile_access') && window.innerWidth <= 768) {
            next({
              name: 'HomeMobile'
            })
          } else {
            next()
          }
        } else {
          this.a.app.$store
            .dispatch("auth/refreshAuthorizations")
            .then(() => {
              this.a.app.$store.dispatch("status/getAll").then(() => {
                this.a.app.$store.dispatch("myaxiloc_setting/getAll").then(() => {

                  // Chargement du message d'annonce d'une opération de maintenance
                  axios.get("myaxilocsetting/maintenance_incoming_message")
                  .then(response => {
                    this.a.app.$store.dispatch('app/setMaintenanceIncomingMessage', response.data.maintenance_incoming_message)
                  })

                  this.a.app.$store.dispatch('app/isLoaded', true)

                  // On vérifie si la page nécessite des autorisations spéciales et si il les a toutes
                  var authorized = true;
                  if (to.matched.some(record => record.meta.authorizations)) {
                    to.meta.authorizations.map(authorization => {
                      if (!this.a.app.$store.getters["auth/isAuthorized"](authorization)) {
                        authorized = false
                      }
                    })
                  }

                  // Si il est autorisé,
                  if (authorized) {
                    // Si il accède à la home, qu'il a l'accès mobile et qu'il est sur un appareil mobile, on le redirige sur la home mobile
                    if (to.name == 'Home' && this.a.app.$store.getters["auth/isAuthorized"]('mobile_access') && window.innerWidth <= 768) {
                      next({
                        name: 'HomeMobile'
                      })
                    } else {
                      next()
                    }
                  } else {
                    this.a.app.$toastr.error("Vous ne possédez pas les autorisations nécessaires pour accéder à la page demandée");
                    next(false)
                  }

                });
              });
            })
        }
      } else {
        window.location.href = `${process.env.MS_OAUTH_URI}?client_id=${process.env.MS_CLIENT_ID}&scope=openid User.Read&response_type=code&sso_reload=true`
      }
    }
  } else {
    next()
  }
})

// Met à jour le titre de l'onglet à partir du titre déclaré dans la route
router.afterEach(to => {
  document.title = to.meta && to.meta.title ? `${to.meta.title} - ${APP_TITLE}` : APP_TITLE
})

export default router



// WEBPACK FOOTER //
// ./src/router.js